/**
 * 报关贴纸管理- 侵权确认页
 *
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import { Row, Col,message,Modal,Result,Button } from 'antd';
import Lang from "@components/Lang/Lang";
import { Spin} from "antd";
import dayjs from "dayjs";
import {isEmpty} from '@utils/utils';
import "./ReviewOperation.less";
import CustomsDeclarationStickerAction from "../../CustomsDeclarationSticker.action";
const config = require("@config/config");
class ConfirmOperation extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            currItem:{},
            list:[],
            handleNum:0,
            modalVisible:false,
            nextTrackId:'',
            noHandleList:[]
        }
    }
    /**
     * 查看详情
     * @iId 订单号
     * @设置当前值
     * @成功后弹出 下一单窗口
     * */
    getDetail(iId='',iCurrInx=0, showSuccess=false){
        if(isEmpty(iId)){
            return
        }
        this.loading(true);
        const postData = {
            eventCode:20,
            id:iId,
            isSkuDetail:0,//是否需要sku详细信息		海关编码传1 其余传0
        }
        CustomsDeclarationStickerAction.getGoodsWaitConfirmDetail(postData).then(res=>this.handleRes(res.data,iCurrInx,showSuccess)).catch(err=>this.handleRes(err))
    }
    handleRes(res,iCurrInx=0,showSuccess){
        const {success,valid,models,model} = res;
        if(success&&valid){
            const nextTrackId = model&&model.nextTrackId; // 下一单可处理ID
            this.setSelectItem(models,iCurrInx,showSuccess,nextTrackId,model) //更新页面 设置选择
        }else if(res.message){
            message.warning(res.message);
            this.loading(false);
        } else this.loading(false);
    }
    // 设置页面 选择项
    setSelectItem(list=[],iCurrInx,showSuccess=false,nextTrackId='',model={}){
        const noHandleList = list.filter(pro=>isEmpty(pro.isTort))||[]; //未处理列表
        const iListNum = list.length;               //所有数量
        const iNoHandleNum = noHandleList.length; // 未处理数量
        if(iNoHandleNum>0){ // 有未处理的
            // 处理当时读取项
            let currItem = {};
            if(iCurrInx==0&&list.length>0){ //如果是第一次进入一般为0直接处理
                // console.log('如果是第一次进入一般为0直接处理', )
                currItem = list[0];
            }else if(iCurrInx<list.length){ //如果正常处理下一个
                // console.log('如果正常处理下一个', )
                currItem = list[iCurrInx];
            }else if(noHandleList.length>0) {// 如果下一个已超出列表项，但未处理完成，跳到未处理的项
                // console.log('如果下一个已超出列表项', )
                currItem = noHandleList[0];
                iCurrInx = list.findIndex(item => item.skuId == currItem.skuId);
            }else {// 否则不改变当时项
                // console.log('否则不改变当时项',this.state.currInx)
                iCurrInx = this.state.currInx;
            }
            this.setState({
                list:list,
                currItem: currItem,
                currInx: iCurrInx,
                handleNum: iListNum - iNoHandleNum,
                noHandleList:noHandleList,
                modalVisible:showSuccess,
                nextTrackId:nextTrackId,
                model:model
            }, ()=>setTimeout(()=>this.loading(false), 400));
        }else if(iNoHandleNum==0){
            // 如果全部已处理 显示第一个
            this.setState({
                list:list,
                currItem: noHandleList.length>0?noHandleList[0]:list[0],
                currInx: 0,
                handleNum: iListNum - iNoHandleNum,
                noHandleList:noHandleList,
                modalVisible:showSuccess,
                nextTrackId:nextTrackId,
                model:model
            }, ()=>setTimeout(()=>this.loading(false), 400))
        }
    }
    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 按钮
     * */
    getCerId(str){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        this.setState({
            iId: iId
        })
        return iId;
    }
    /**
     * 正常|侵权按钮点击 提交事件
     * @iId 当前处理Po单Id
     * @currItem 当前处理项
     * @isTort 是否侵权 0 正常 1 侵权
     * */
    onClickConfirmGoods(iId,currItem={},isTort=''){
        if(isEmpty(iId)||isEmpty(currItem.poItemId)){
            return
        }
        this.loading(true);
        const { noHandleList } = this.state; //未处理列表
        let iIsSubmit = 0; // 默认不提交
        let showSuccess = false;
        if(noHandleList.length==0){ //历史数据 去提交
            showSuccess = true;
            iIsSubmit=1;
        }
        if(noHandleList.length==1){ // 未处理列表只剩下一个且为当前项，则改为提交数据
            const postItem = noHandleList.find(item=>item.skuId==currItem.skuId);
            if(postItem&&postItem.skuId){
                showSuccess = true;
                iIsSubmit=1;
            }
        }
        let postData = {
            isTort:isTort,
            isSubmit:iIsSubmit,
            skuId: currItem.skuId,
            poItemId:currItem.poItemId,
        }
        if(!isEmpty(currItem.salePoStickerTrackId))postData['salePoStickerTrackId'] = currItem.salePoStickerTrackId; //流程id 有就传 没有就不传
        if(!isEmpty(currItem.id))postData['id'] = currItem.id;
        CustomsDeclarationStickerAction.updateAuditGoods(postData).then(res=>this.handleConfirmRes(res.data,showSuccess)).catch(err=>this.handleConfirmRes(err))
    }
    handleConfirmRes(res,showSuccess){
        this.loading(false);
        const {success,valid} = res;
        if(success&&valid){
            const {iId,currInx,} = this.state;
            // 成功后重新读取 列表
            this.getDetail(iId,currInx+1,showSuccess);
        }else if(res.message){
            message.warning(res.message);
        }else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));

    }
    /**
     * 处理上一个下一个
     * @currInx 需要设置的当前项目在列表中的序号
     * @list 列表
     **/
    handleSelect(selectInx=0,list=[]){
        if(selectInx>=0&&selectInx<list.length){
            this.loading(true);
            const newItem = list[selectInx];
            this.setState({
                currItem:newItem,
                currInx:selectInx,
            },()=>{
                setTimeout(()=>this.loading(false),400)
            });
        }
    }
    /**
     * 关闭弹窗
     */
    setModalVisible(flag){
        this.setState({
            modalVisible:flag
        })
    }
    /**
     * 获取下一步
     * **/
    getNextOption(nextTrackId){
        let resBtn = [];
        if(!isEmpty(nextTrackId)) {
            resBtn.push(<Button type="primary" key="console" onClick={()=>this.renderNextDetail(nextTrackId)}>
                {Lang({id: "XiaYiDan",default: "下一单"})}
            </Button>)
        }else resBtn.push(<Button type="primary" key="console" onClick={()=>this.backList()}>
            {Lang({id: "GuanBi",default: "关闭"})}
        </Button>)
        return resBtn;
    }
    /**
     * 渲染下一单
     * @nextTrackId
     ***/
    renderNextDetail(nextTrackId){
        this.props.history.push('/customsDeclarationSticker/reviewWork?'+nextTrackId)
        this.setState({
            iId: nextTrackId
        },() =>this.getDetail(nextTrackId,0,false));
    }
    //返回列表
    backList(){
        this.loading(true);
        this.setModalVisible();
        setTimeout(()=>{
            this.props.history.push('/customsDeclarationSticker/review')
            this.loading(false);
        },400);
    }
    /**
     * 隐藏
     * */
    onChangeClickHidden(flag){
        const {currItem } = this.state;
        this.setState({
            currItem: {...currItem,hidden: flag }
        })
    }
    componentDidMount() {
        const { search } = this.props.location;
        const iId = this.getCerId(search);
        this.getDetail(iId,0);
    }
    render(){
        const { loading,currItem,list,currInx,iId,handleNum,modalVisible,nextTrackId,model } = this.state;
        const currPageName = Lang({id: "QinQuanShenHe",default: "侵权审核"});
        const tortRemarkList = currItem.tortRemarkList || [];
        return (<Spin tip='loading' spinning={loading}>
            <CommonBreadcrumb list={[
                { name:currPageName,link:'/customsDeclarationSticker/review'},{name:model&&model.poCode?model.poCode:''}]}></CommonBreadcrumb>
            <div className="reviewOperationStyle">
                <div className={'top'}>
                    <Row className={'info'}>
                        <Col>{Lang({id: 'ShangPinBianMa', default: '商品编码'})}<span>{currItem.skuNo}</span></Col>
                        <Col offset={1}>{Lang({id: 'ShangYiJiShenHeRen', default: '上一级审核人'})}<span>{currItem.superiorAuditor}</span></Col>
                        <Col offset={1}>{Lang({id: 'ShenHeShiJian', default: '审核时间'})}<span>{currItem.auditTime?dayjs(currItem.auditTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</span></Col>
                        {tortRemarkList.length>0&&<Col offset={1}>
                            <div className={"btn_hidden"} onClick={()=>this.onChangeClickHidden(!currItem.hidden)}><i className="ri-eye-line color-white"></i> {Lang({id: 'QinQuanYuanYin', default: '侵权原因'})}</div>
                        </Col>}

                    </Row>
                    <div className={'info title'}>{Lang({id: 'SKUPinMing', default: '商品品名'})}
                      <span className={'font_16'}>
                        <a href={config.servers[config.environment].portalUrl+`/${currItem.goodsId}.html?skuNo=${currItem.skuNo}`} target={'_blank'}>{currItem.skuName}</a>
                        </span>
                    </div>
                </div>
                <div className={'content'}>
                    {!currItem.hidden&&tortRemarkList.length>0&&<div className={"tort_mst"}>{Lang({id: 'QinQuanYuanYin', default: '侵权原因'})}：{tortRemarkList.map((txt,txInx)=><span className={"margin-right-12"}>{txInx+1}.{txt}</span>)}</div>}
                    {currItem.skuFileUrls&&currItem.skuFileUrls.length>0&&<img src={currItem.skuFileUrls[0]} alt={currItem.skuName} title={currItem.skuName} />}
                </div>
                <div className={'footer'}>
                        <div className={'footer-left'}>
                            <span className={'letter-spacing-2'}>{currInx+1}/{list.length}</span>
                            {/* 下一个 */}
                            <span className={currInx-1<0?'btnDisable':'btn'} onClick={()=>this.handleSelect(currInx-1,list)}>{Lang({id:'ShangYiGe',default:'上一个'})}</span>
                            {/* 下一个 */}
                            <span className={currInx+1==list.length?'btnDisable':'btn'} onClick={()=>this.handleSelect(currInx+1,list)}>{Lang({id:'XiaYiGe',default:'下一个'})}</span>

                        </div>
                        <div className={'footer-center'}>
                                    <span className={currItem.isTort==0?'btn btn-red on':'btn btn-red'} onClick={()=>this.onClickConfirmGoods(iId,currItem,0)}>
                                        <i className="iconfont icon-check"></i>
                                        {Lang({id: 'BuQinQuan', default: '不侵权'})}
                                    </span>
                            <span  className={currItem.isTort==1?'btn btn-red on':'btn btn-red'} onClick={()=>this.onClickConfirmGoods(iId,currItem,1)}>
                                        {/*{activeBtn=='Infringement'&&<i className="iconfont icon-check"></i>}*/}
                                    <i className="iconfont icon-check"></i>
                                    {Lang({id: 'QueRenXiaYiGe', default: '确认侵权'})}
                                    </span>
                        </div>
                        <div className={'footer-right'}>
                            <span> {Lang({id: 'YiChuLi', default: '已处理'})}( {handleNum} )</span>
                        </div>
                </div>
            </div>
            {modalVisible&&<Modal
                open={modalVisible}
                footer={null}
                onCancel={()=>this.backList(false)}
            >
                <Result
                    status="success"
                    onCancel={()=>this.backList(false)}
                    title={Lang({id: 'GaiDingDanQuanBuShangPinYiChuLi', default: '该订单全部商品已处理'})}
                    extra={this.getNextOption(nextTrackId)}
                />
            </Modal>}
        </Spin>)
    }
}
export default ConfirmOperation;